import { useMemo } from 'react';

type TimeProps = {
    value: Date;
}

export const Time = ({ value }: TimeProps) => {
    const time = useMemo(() => {
        const hours = value.getHours();
        const minutes = value.getMinutes();

        return hours * 60 + minutes;
    }, [value]);

    return (
        <>
            {time}
        </>
    );
};
